import { useOrganizationList, useUser } from '@clerk/clerk-react';

export const getRedirectPath = async (): Promise<{ path: string; message: string }> => {
    const token = sessionStorage.getItem('clerk-auth-token');

    if (!token) {
        return {
            path: '/home',
            message: 'Redirecting to home page...'
        };
    }

    try {
        const response = await fetch('https://api.clerk.dev/v1/user_organization_memberships', {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch organizations');
        }

        const orgs = await response.json();

        if (orgs?.data?.length > 0) {
            const firstOrg = orgs.data[0].organization;
            if (firstOrg.slug) {
                return {
                    path: `/${firstOrg.slug}`,
                    message: 'Redirecting to your organization...'
                };
            } else {
                return {
                    path: '/dashboard',
                    message: 'Setting up your organization...'
                };
            }
        } else {
            return {
                path: '/create-org',
                message: 'Redirecting to create organization...'
            };
        }
    } catch (error) {
        console.error('Error determining redirect path:', error);
        return {
            path: '/dashboard',
            message: 'Setting up your session...'
        };
    }
};

export const isPublicPath = (path: string): boolean => {
    if (path === '/home') {
        return true;
    }

    const publicPaths = [
        '/',
        '/sign-in',
        '/sign-up',
        '/dashboard',
        '/create-org',
        '/templates',
        '/pricing',
        '/hackathon',
        '/hackathon/register',
        '/hackathon/submit',
        '/blog',
        // Platform Section - Landing Page Routes
        '/platform/visual-editor',
        '/platform/agent',
        '/platform/projects-dashboard',
        '/platform/live-previews',
        '/platform/team-collaboration',
        '/platform/export-and-share',
        // Solutions Section - Landing Page Routes
        '/solutions/for-engineers',
        '/solutions/for-ops-and-analysts',
        '/solutions/for-students',
        '/solutions/for-researchers',
        '/solutions/for-internal-tools',
        '/solutions/for-interactive-reports',
        '/solutions/for-exploratory-analysis',
        '/solutions/for-client-facing-dashboards',
        '/solutions/for-enterprises',
        '/solutions/for-governments',
    ];

    return publicPaths.includes(path) || path.startsWith('/settings/organization') || path.startsWith('/settings/account');
}; 